<template>
  <kst-page-report 
    :catalog="PlosSearchCatalog"
    :params="Model.Search.ListParams"
    :search="searchData"
    @init="handleInit"
    @load="handleLoad"
    @loaded="handleLoaded"
    @reset="handleReset"
  >
    <template #search="{ handleInput }">
      <Search
        :searchData="searchData"
        :warehouseOptions="warehouseOptions"
        @input="handleInput"
      />
    </template>

    <template #search-result>
      <Result
        :chartData="chartData"
        :summaryData="summaryData"
        :searchData="searchData"
      />
    </template>
  </kst-page-report>
</template>

<script>
import Model from "../PlosModel.js";
import PlosSearchCatalog from "../PlosSearchCatalog.js";
import Services from "../../../services/Api/ProfitLossServices.js";

import Result from "./PlosR_Result.vue";
import Search from "./PlosR_Search.vue";

export default {
  components: {
    Result,
    Search
  },
  data: () => ({
    Model: Model,
    PlosSearchCatalog: PlosSearchCatalog,
    access: {},
    chartData: {},
    summaryData: {},
    searchData: {
      Date: null,
      WarehouseID: null,
      // by system
      RptTypeID: null
    },
    warehouseOptions: {}
  }),
  created() {
    this.resetSearch();
  },
  methods: {
    /*** by page ***/

    handleInit(loadReportData) {
      this.resetData();

      const options = this.getOptions();
      const config = Services.getReportData(options);
      loadReportData(config, this.handleInit_success);
    },
    handleInit_success(data) {
      this.warehouseOptions = Model.getWarehouseOptions(
        data.WarehouseList, PlosSearchCatalog.WarehouseID.Label
      );

      this.searchData.RptTypeID = data.CompanySettingDetails.ProfitLossRptTypeID;
      this.updateResult(data.TransactionDetails);
    },

    handleLoad(loadReport) {
      const options = this.getOptions();
      const config = Services.getReport(options);
      loadReport(config);
    },

    handleLoaded(data) {
      this.searchData.RptTypeID = data.CompanySettingDetails.ProfitLossRptTypeID;
      this.updateResult(data.TransactionDetails);
    },

    handleReset() {
      this.resetSearch();
    },

    /*** custom ***/

    resetData() {
      this.access = this.$kst.Access.create(Model.Access);
      this.chartData = Model.createChart();
      this.summaryData = Model.createSummary();
      this.warehouseOptions = {};

      this.resetData_search();
    },
    resetData_search() {
      if (this.searchData.WarehouseID === null) {
        this.searchData.WarehouseID = this.$kst.Session.getDefaultWarehouseID();
      }
    },

    resetSearch() {
      this.searchData.Date = this.$kst.In.getDefaultDateRange();
      this.searchData.WarehouseID = this.$kst.Session.getDefaultWarehouseID();
      // by system
      this.searchData.RptTypeID = null;
    },

    getOptions() {
      return {
        startdate: this.$kst.Out.getDateString(this.searchData.Date[0]),
        enddate: this.$kst.Out.getDateString(this.searchData.Date[1]),
        warehouse: this.$kst.Search.getValue(this.searchData.WarehouseID)
      };
    },

    updateResult(transactionDetails) {
      this.chartData = Model.Report.getChart(transactionDetails,
        this.searchData
      );
      this.summaryData = Model.Report.getSummary(transactionDetails,
        this.access, this.searchData
      );
    }
  }
}
</script>